import { Container, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import Header from '../components/Header';
import QRCodeGenerator from '../components/QRCodeGenerator';

const SCREEN = 'complete';

const Complete = () => {
  const { t } = useTranslation();
  const header = useSelector((state: RootState) => state.header);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
        <Header title={t(`${SCREEN}.title`)} />
        <Typography variant="body1" align="center">
          {t(`complete.done`)}{t(`complete.thanks`)}<br />
          {t(`complete.message`)}
        </Typography>
        <QRCodeGenerator acctNo={header.acctNo} />
      </Paper>
    </Container>
  );
}
export default Complete;
